<div class="search-container-details stats-border-radius">
    <div class="tab-title-icon">
        <cll-icon class="tab-icon" type="outlined">inventory_2</cll-icon>
        <div class="accordion-sub-title-accordion">
            <span class="detail-table-title">{{ title }}</span>
            <span class="detail-table-sub-title">{{ subTitle }}</span>
        </div>
    </div>
    <div class="inbox-search-container">
        <cll-form-field label="Type a keyword...">
            <cll-icon cllPrefix>search</cll-icon>
            <input [formControl]="searchControl"
                   cllFormInput
                   type="text">

            @if (searchControl.value) {
                <button type="button" (click)="searchControl.reset()"
                        cll-icon-button
                        cllTooltip="Clear search query"
                        cllSuffix>
                    <cll-icon>clear</cll-icon>
                </button>
            }
        </cll-form-field>
    </div>
</div>
<div class="stats-table-container">
    @if (pageResult(); as request) {
        @if (request.isLoading) {
            <cll-spinner />
        }

        @if (request.error; as error) {
            <app-error-panel [error]="error"/>
        }

        @if (request.value; as page) {
            <table class="cll-table stats-table">
                <thead class="sticky-table-top">
                <tr>
                    @for (column of columns; track column.key) {
                        <th>{{ column.value }}</th>
                    }
                </tr>
                </thead>
                <tbody>
                    @if (page.data.length === 0) {
                        <tr>
                            <td attr.colspan="{{columns.length}}" class="no-data-row">
                                <div class="no-data-wrapper">
                                    No packages found.
                                </div>
                            </td>
                        </tr>
                    } @else {
                        @for (packageRow of page.data; track $index) {
                            <tr class="stats-row" (click)="openPackageInNewTab(packageRow[0])">
                                @for (column of columns; let i = $index; track column.key) {
                                    <td>
                                        {{ packageRow[i + 1] }}
                                    </td>

                                }
                            </tr>
                        }
                    }
                </tbody>
            </table>
        }
    }
    <app-pagination-card
        (page)="setPage($event)"
        [meta]="meta()"
    />
</div>
